import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { STEP_CHECKPOINT_SCHEMA_VERSION } from './constants';

/**
 * Lightweight checkpoint index. Heavy mesh buffers live in `meshSnapshot.js`.
 *
 * @typedef {import('./types').StepCheckpointRecord} StepCheckpointRecord
 */

const useStepCheckpointStore = create(
  devtools((set, get) => ({
    /** @type {Record<string, StepCheckpointRecord>} */
    checkpoints: {},

    /** True while a step restore is in flight (handlers should defer side effects). */
    isRestoring: false,

    activeStepId: null,

    hasCheckpoint: (stepId) => !!get().checkpoints[stepId]?.hasMesh,

    getCheckpoint: (stepId) => get().checkpoints[stepId] ?? null,

    setCheckpoint: (stepId, record) =>
      set((state) => ({
        checkpoints: {
          ...state.checkpoints,
          [stepId]: {
            schemaVersion: STEP_CHECKPOINT_SCHEMA_VERSION,
            stepId,
            savedAt: Date.now(),
            ...record,
          },
        },
      })),

    setIsRestoring: (isRestoring) => set({ isRestoring }),

    setActiveStepId: (activeStepId) => set({ activeStepId }),

    removeCheckpoint: (stepId) =>
      set((state) => {
        if (!state.checkpoints[stepId]) return state;
        const { [stepId]: _removed, ...rest } = state.checkpoints;
        return { checkpoints: rest };
      }),

    clearAll: () => set({ checkpoints: {}, isRestoring: false, activeStepId: null }),
  })),
);

export default useStepCheckpointStore;
